import React, { Component, Fragment} from 'react';
import {connect} from 'react-redux';

import Plyr from 'react-plyr';
import ReactPlayer from 'react-player'

import './Homeblock.module.scss';


import Modal from 'react-responsive-modal';


import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import{ faTimes as faTimesLight} from '@fortawesome/pro-light-svg-icons';

import generateClipPath from 'utilities/generateClipPath'

/**
 * import components
 */
import CardPopup from 'components/UI/CardPopup/CardPopup'


//import page components
import Image        from 'components/UI/PageComponents/image/Image';
import TextBlock    from 'components/UI/PageComponents/TextBlock/TextBlock';
import Title        from 'components/UI/PageComponents/Title/Title';
import Button       from 'components/UI/PageComponents/Button/Button';
import Video        from 'components/UI/PageComponents/Video/Video';

import Accordion from 'components/UI/Accordion/Accordion';




const mapStateToProps = (state, props) => {
    return {
        blocks: state.block.entities,
        lessons: state.lesson.entities
    };
};

const mapDispatchToProps = {
};

class Homeblock extends Component {

    constructor() {
        super();
        this.state = {
            open: false,
            mobileView: true,
            hover: false,
            video: false,
        }

        this.openModal      = this.openModal.bind(this);
        this.closeModal     = this.closeModal.bind(this);

        //this.handleResize   = this.handleResize.bind(this);
        this.hoverOn        = this.hoverOn.bind(this);
        this.hoverOff       = this.hoverOff.bind(this);
    }


    openModal(event) {
        event.preventDefault();
        this.setState({
            open: true
        });
        //window.scrollTo(0,0)
    }

    closeModal() {
        this.setState({
            open: false
        });
        
        //window.scrollTo(0,0)
    }

    // componentDidMount(){
    //     this.handleResize()
    //     window.addEventListener("resize", this.handleResize);
    // }

    // handleResize(){
    //     let mobileViewCheck = window.innerWidth < 1100 ? true : false;
    //     this.setState({
    //         mobileView: mobileViewCheck
    //     });
    //     console.log('handleresize')
    // }
    hoverOn(){
        this.setState({ hover: true})
    }
    hoverOff(){
        this.setState({ hover: false})
    }

    render() {
        let {item, mobileView} = this.props;

        let card = this.props.lessons.byId[item.lesson_id]
        return (
            <Fragment>
                {
                    !item.video ?
                <a
                    onMouseEnter={this.hoverOn} onMouseLeave={this.hoverOff}
                    href={`${
                        //if link_type is file link with storage else item.link
                        item.link_type == 'file' ? `/storage/${item.link_file}` : item.link
                    }`}
                    target={`${(item.link_type == 'link_external') ? '_blank' : '_self'}`}
                    download={item.link_type == 'file'}
                    onClick={(item.link_type === 'popup' || item.link_type === 'lesson') ? this.openModal : undefined} 
                    styleName={`block`} 
                style={{
                    gridArea: `${mobileView ? 'auto' : item.position.row_start} / ${mobileView ? 'auto' : item.position.column_start} / span ${item.position.height} / span ${mobileView ? '2' : item.position.width}`, 
                    backgroundImage:`${(this.state.hover && item.image_hover) ? `url(/storage/${item.image_hover})` : `url(/storage/${item.image})`}`, 
                    backgroundColor: `${item.colors.background}`,
                    clipPath: generateClipPath(0,20,0,3, 1100, 1100),
                    pointerEvents: `${item.link_type == null ? 'none' : 'auto'}`
                }}>
                    {item.name && 
                        <h2 style={{
                            color: `${item.colors.text_title}`, 
                            backgroundColor: `${item.colors.title_background ? item.colors.title_background : 'transparent'}`,
                            clipPath: `${item.colors.title_background ? generateClipPath(0,15,0,2, 1100, 1100) : null}`,
                            padding: `${item.colors.title_background ? '10px' : '0px'}`
                        }}>{item.name}</h2>
                    }
                    {item.content &&
                        <p style={{
                            backgroundColor: `${item.colors.text_background ? item.colors.text_background : 'transparent'}`,
                            color: `${item.colors.text_content}`,
                            clipPath: generateClipPath(0,15,0,2, 1100, 1100),
                        }}>{item.content}</p>
                    }
                </a>   
                :
                <div
                    styleName={`block`} 
                    style={{
                        padding: '0px',
                        gridArea: `${mobileView ? 'auto' : item.position.row_start} / ${mobileView ? 'auto' : item.position.column_start} / span ${item.position.height} / span ${mobileView ? '2' : item.position.width}`, 
                        clipPath: generateClipPath(0,20,0,3, 1100, 1100),
                    }}
                >
                    {item.video_type == 'vimeo' ?
                        <Plyr
                            type="vimeo" // or "vimeo"
                            videoId={item.video}
                        />
                    :
                        <iframe allowFullScreen style={{width:'100%', height:'100%'}} src={`https://www.youtube.com/embed/${item.video}`} frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"></iframe>
                    }
                </div>  
                }   



                {/* modal section ------------------------------------------------------------------*/}





            <Modal open={this.state.open} onClose={this.closeModal} styles={{
                modal: {
                padding:'0px',
                margin:'auto',
                backgroundColor:'transparent',
                WebkitBoxShadow: '-0px 0px 0px 0px rgba(0, 0, 0, 0)',
                MozBoxShadow: '-0px 0px 0px 0px rgba(0, 0, 0, 0)',
                boxShadow: '-0px 0px 0px 0px rgba(0, 0, 0, 0.)',
                width: '100%',
                position: 'Static',
                },
                closeButton:{
                    display:'none'
                },
                overlay:{
                    backgroundColor:'rgba(57, 59, 81, 0.8)',
                    paddingTop: `${this.props.item.link_type == 'lesson' ? '100px' : null}`
                }
                }}>
                    
                    <p onClick={this.closeModal} styleName='cross'><FontAwesomeIcon icon={faTimesLight}/></p>
                    {this.props.item.link_type == 'popup' ?
                        <Fragment>
                            <div style={{clipPath: generateClipPath(0,20,0,3, 1100, 6000),}} styleName='modal'>
                                {/* als er een image is of een titel dan render anders niet */}
                                {(item.name || item.image_popup) &&
                                <div style={{
                                    backgroundColor: `${item.colors.background}`,
                                }} styleName='background-image'
                                    style={{backgroundColor: `${item.colors.popup_background}`}}
                                >
                                    {item.image_popup &&
                                        <img styleName='modal-image' src={`${`/storage/${item.image_popup}`}`} alt=''/>   
                                    }
                                </div>
                                }
                                
                                <div styleName='container-text'>
                                    { item.name &&
                                        <h1 styleName='popup-title'>{item.name}</h1>
                                    }
                                    <div>
                                        {
                                            item.popup &&
                                            item.popup.map(function(item2, i){
                                                if(item2.layout == 'image'){
                                                    return(
                                                        <Image key={i} image={item2.attributes.image}/>
                                                    );
                                                }
                                                if(item2.layout == 'text'){
                                                    return(
                                                        <TextBlock key={i} content={item2.attributes.text} />
                                                    );
                                                }
                                                if(item2.layout == 'title'){
                                                    return(
                                                        <Title key={i} title={item2.attributes.title} />
                                                    );
                                                }
                                                if(item2.layout == 'button'){
                                                    return(
                                                        <Button item={item2.attributes} key={i} />
                                                    );
                                                }
                                                if(item2.layout == 'video'){
                                                    return(
                                                        <Video item={item2.attributes} key={i}/>
                                                    );
                                                }
                                            }, this)
                                        } 
                                    </div>
                                </div>
                            </div>
                        </Fragment>
                    :
                        <CardPopup home card={card}/>
                    }
                </Modal>
            </Fragment>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Homeblock);